// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1sHex","imageUploader":"EGiftCard_imageUploader__2DKq3"};